<template>
  <summary-count title="Disputed Charges" :is-loading="isLoading" :count="disputes" :change-count="null" @cardClicked="gotoLink()" />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";

export default {
  name: "Activities",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      disputes: 0,
      isLoading: false,
    };
  },
  created() {
    this.loadDisputes();
  },
  methods: {
    loadDisputes() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/disputes`;

      this.$axios
        .get(url, {})
        .then((res) => {
          this.disputes = res.data.disputes;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gotoLink() {
      this.$router.push(`/businesses/${this.businessId}/disputes`);
    },
  },
};
</script>
